import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { setAccessToken } from "../services/api";
import "./Otp.css";
import AccountHomeButton from "../pages/Auth/account-home-button";
import SuccessPopup from "./SuccessPopup";
import ErrorPopup from "./ErrorPopup";

const Otp = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const location = useLocation();
  const navigate = useNavigate();

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const redirectPath = "/dashboard/business/user/profile";

  const handleChange = (value, index) => {
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== "" && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) inputRefs.current[index - 1]?.focus();
    }
  };

  const showSuccess = (message) => {
    setPopupMessage(message);
    setShowErrorPopup(false);
    setShowSuccessPopup(true);
  };

  const showError = (message) => {
    setPopupMessage(message);
    setShowSuccessPopup(false);
    setShowErrorPopup(true);
  };

 const handleSuccessClose = () => {
  setShowSuccessPopup(false);
  navigate(redirectPath);
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userId = location.state?.userId;

    if (!userId) {
      showError("Missing user information. Please log in again.");
      return;
    }

    try {
      const otpValue = otp.join("");

      const { data } = await api.post("/verify-otp", {
        userId,
        otp: otpValue,
      });

      setAccessToken(data.accessToken);

showSuccess("OTP verified successfully.");
    } catch (err) {
      showError(err?.response?.data?.message || "Invalid or expired OTP");
    }
  };

  return (

    <div className="otp-body">
    <div className="otp-logobody">
                <img
                  src="/logo670.png"
                  alt="PayWeek Logo"
                  className="otp-logo"
                />
            </div>

    
      <AccountHomeButton />

       

      <div className="otp-container">
        <h2>OTP Verification</h2>

<p className="otp-message">
  A 6-digit verification code has been sent to your registered mobile number.
  Enter the code below to continue.
</p>
        <form onSubmit={handleSubmit}>
          <div className="otp-inputs">
            {otp.map((value, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                value={value}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(el) => (inputRefs.current[index] = el)}
              />
            ))}
          </div>

          <button type="submit">Verify</button>
        </form>
      </div>

      {showSuccessPopup && (
        <SuccessPopup
          title="Success"
          message={popupMessage}
          onClose={handleSuccessClose}
          buttonLabel="Done"
        />
      )}

      {showErrorPopup && (
        <ErrorPopup
          title="Error"
          message={popupMessage}
          onClose={() => setShowErrorPopup(false)}
          buttonLabel="Close"
        />
      )}
    </div>
  );
};

export default Otp;


// import React, { useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import api, { setAccessToken } from "../services/api";
// import "./Otp.css";
// import AccountHomeButton from "../pages/Auth/account-home-button";
// import SuccessPopup from "./SuccessPopup";
// import ErrorPopup from "./ErrorPopup";

// const Otp = () => {
//     const [otp, setOtp] = useState(new Array(6).fill(""));
//     const inputRefs = useRef([]);
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//       const [showErrorPopup, setShowErrorPopup] = useState(false);
//       const [popupMessage, setPopupMessage] = useState("");

//     const handleChange = (value, index) => {
//         if (isNaN(value)) return; // Only allow numbers

//         const newOtp = [...otp];
//         newOtp[index] = value;
//         setOtp(newOtp);

//         // Move to the next input if not the last box
//         if (value !== "" && index < 5) {
//             inputRefs.current[index + 1].focus();
//         }
//     };

//     const handleKeyDown = (e, index) => {
//         if (e.key === "Backspace" && otp[index] === "") {
//             // Move to the previous input on backspace
//             if (index > 0) inputRefs.current[index - 1].focus();
//         }
//     };

//     const showSuccess = (message) => {
//     setPopupMessage(message);
//     setShowErrorPopup(false);
//     setShowSuccessPopup(true);
//   };

//   const showError = (message) => {
//     setPopupMessage(message);
//     setShowSuccessPopup(false);
//     setShowErrorPopup(true);
//   };

//   const handleSuccessClose = () => {
//     setShowSuccessPopup(false);
//     navigate("/dashboard/business/user/profile");
//   };


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const userId = location.state.userId;

//         try {
//             const otpValue = otp.join(""); // Combine all boxes into a single string
//             const { data } = await api.post("/verify-otp", { userId, otp: otpValue });
//             setAccessToken(data.accessToken);
//             showSuccess("OTP verified successfully");
//         } catch (err) {
//             showError(err?.response?.data?.message || "Invalid or expired OTP");
//         }
//     };

//     return (
//         <div className="otp-body">
//         <AccountHomeButton/>
//         <div className="otp-container">
//             <h2>OTP Verification</h2>
//             <form onSubmit={handleSubmit}>
//                 <div className="otp-inputs">
//                     {otp.map((value, index) => (
//                         <input
//                             key={index}
//                             type="text"
//                             maxLength="1"
//                             value={value}
//                             onChange={(e) => handleChange(e.target.value, index)}
//                             onKeyDown={(e) => handleKeyDown(e, index)}
//                             ref={(el) => (inputRefs.current[index] = el)}
//                         />
//                     ))}
//                 </div>
//                 <button type="submit">Verify</button>
//             </form>
//         </div>
//         {showSuccessPopup && (
//   <SuccessPopup
//     title="Success"
//     message={popupMessage}
//     onClose={handleSuccessClose}
//     buttonLabel="Done"
//   />
// )}

// {showErrorPopup && (
//   <ErrorPopup
//     title="Error"
//     message={popupMessage}
//     onClose={() => setShowErrorPopup(false)}
//     buttonLabel="Close"
//   />
// )}
//         </div>
        
//     );
// };

// export default Otp;




// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import api, { setAccessToken } from "../services/api";
// import "./Otp.css";

// const Otp = () => {
//     const [otp, setOtp] = useState("");
//     const location = useLocation();
//     const navigate = useNavigate();

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const userId = location.state.userId;

//         try {
//             const { data } = await api.post("/verify-otp", { userId, otp });
//             setAccessToken(data.accessToken);
//             alert("OTP verified successfully!");
//             navigate("/dashboard");
//         } catch (err) {
//             alert("Invalid or expired OTP.");
//         }
//     };

//     return (
//         <div className="otp-container">
//             <h2>OTP Verification</h2>
//             <form onSubmit={handleSubmit}>
//                 <input
//                     type="text"
//                     placeholder="Enter OTP"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     required
//                 />
//                 <button type="submit">Verify</button>
//             </form>
//         </div>
//     );
// };

// export default Otp;







// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import api, { setAccessToken } from "../services/api";

// const Otp = () => {
//     const [otp, setOtp] = useState("");
//     const location = useLocation();
//     const navigate = useNavigate();

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const userId = location.state.userId;

//         try {
//             const { data } = await api.post("/verify-otp", { userId, otp });
//             setAccessToken(data.accessToken);
//             alert("OTP verified successfully!");
//             navigate("/dashboard");
//         } catch (err) {
//             alert("Invalid or expired OTP.");
//         }
//     };

//     return (
//         <div>
//             <h2>OTP Verification</h2>
//             <form onSubmit={handleSubmit}>
//                 <input placeholder="Enter OTP" onChange={(e) => setOtp(e.target.value)} required />
//                 <button type="submit">Verify</button>
//             </form>
//         </div>
//     );
// };

// export default Otp;
